export function getLastSelectedCollectionId(workspaceId) {
	// Extension uses localStorage, because every new session opens in a new tab
	// and sessionStorage wouldn't remember the selected collection across sessions.
	if (import.meta.env.VUE_APP_TARGET === 'extension') {
		return localStorage?.[`lastSelectedCollectionId.${workspaceId}`]
	}
	// In the web app, the user can have multiple sessions from different collections open, in which case the session's
	// collection should be selected in every tab, and reloading the tabs should re-select the different collections again.
	// In case a user opens the dashboard in a new tab, it should select the last selected collection.
	// That's why tab-specific session storage is the source of truth if present, but localStorage provides a
	// fall-back which remembers the selected collection across tabs.
	return (
		sessionStorage?.[`lastSelectedCollectionId.${workspaceId}`] ||
		localStorage?.[`lastSelectedCollectionId.${workspaceId}`]
	)
}

export function setLastSelectedCollectionId(collectionId, workspaceId) {
	if (localStorage) localStorage[`lastSelectedCollectionId.${workspaceId}`] = collectionId
	if (sessionStorage) sessionStorage[`lastSelectedCollectionId.${workspaceId}`] = collectionId
}

export default {
	getLastSelectedCollectionId,
	setLastSelectedCollectionId,
}
